@if (showNewHeader) {
    <!-- pix header -->
    <div class="header-ctrl-wrapper pix-header" id="qdHeader">
        <div class="header-ctrl d-flex justify-content-between align-items-center">
            <div class="header-ctrl-txt">{{ 'PARTY.CASHIER.web.deposit.header' | translate }}</div>
            <div class="header-ctrl-r" (click)="closeCashier()">
                <span aria-label="close" class="non-mgm ui-icon ui-icon-size-sm ui-close theme-ex"></span>
            </div>
        </div>
    </div>
} @else {
    <div class="qd-header position-relative" id="qdHeader">
        <strong
            >{{ 'PARTY.CASHIER.web.deposit.header' | translate }}
            <div class="header-ctrl-r w-auto" (click)="closeCashier()">
                @if (isBetmgmLabel) {
                    <span class="mgm-3 txt-link">
                        {{ 'PARTY.CASHIER.web.deposit.headercancel.text' | translate }}
                    </span>
                } @else {
                    <span aria-label="close" class="non-mgm ui-icon ui-icon-size-sm ui-close theme-ex"></span>
                }
            </div>
        </strong>
    </div>
}
